import styled, { keyframes, css } from 'styled-components';
import { EllipsisWithLineClamp } from '@simplywallst/ui-core';

const cubicBezier = `cubic-bezier(0.23, 1, 0.32, 1)`;

const showSnowflake = keyframes`
  0%          { opacity: 0; }
  100%        { opacity: 1; }
`;

const fadeInSnowflake = css`
  animation: ${showSnowflake} 0.5s ${cubicBezier} 0s forwards;
`;

export const DesktopSidebarWithSnowflakeWrapper = styled('section')`
  position: fixed;
  top: 80px;
  width: ${({ theme }) => theme.sidebarWidth}px;
  padding: ${({ theme }) => `${theme.x1spacePx}px ${theme.x3spacePx}px 0 0`};
`;

export const DesktopSidebarWrapper = styled('div')`
  position: fixed;
  top: 375px;
`;

interface ToggleProps {
  animate?: boolean;
}

export const ToggleWrapper = styled('div')<ToggleProps>`
  ${({ animate }) => animate && fadeInSnowflake}
`;

export const ToggleSnowflake = styled('div')<ToggleProps>`
  padding-bottom: 25px;
  ${({ animate }) => animate && fadeInSnowflake}
`;

export const SnowflakeWrapper = styled('div')<{ toggleMe?: boolean }>`
  margin: ${({ theme }) => `-18px -${theme.x1spacePx}px`};
  max-width: 160px;
`;

export const ActionsWrapper = styled('div')`
  margin-top: ${({ theme }) => theme.x2spacePx - 4}px;
`;

export const SidebarWrapper = styled('div')`
  margin: ${({ theme }) => `-${theme.x1spacePx}px 0 0 -${theme.x3spacePx}px`};
`;

export const MainTitle = styled('p')`
  ${({ theme }) => theme.typography.smallStrong}
  margin: 0;
  margin-top: -10px;
  ${EllipsisWithLineClamp(1)};
`;

export const Title = styled('p')`
  margin: 0;
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
  ${({ theme }) => theme.typography.xSmall}
`;

export const TitleLight = styled('p')`
  margin: 0;
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
  ${({ theme }) => theme.typography.tiny}
  margin-top: 2px;
`;
